(function ($, w, undefined) {
    var _replace = function (haystack, needle) {
        haystack = $(haystack);
        needle = $(needle);
        needle = needle.filter(':not(.j-ajax-ignore)');
        needle.find('.j-ajax-ignore').remove();
        var scripts = needle.filter('script').add(needle.find('script'));
        needle = needle.filter(':not(script)');

        needle.insertAfter(haystack);

        haystack.remove();

        scripts.each(function () {
            var html = $(this).html();

            eval(html);
        });
        CatalogBuilder.init();
    };

    var cache = null;

    var CatalogBuilder = {
        url: w.location.pathname,

        loading: false,

        initialPage: null,

        initialized: false,

        readByKey: function (key) {
            return this.html_cache[key] ? this.html_cache[key] : null;
        },

        writeByKey: function (key, value) {
            this.html_cache[key] = value;
        },

        clearCache: function () {
            this.html_cache = {};
        },

        html_cache: {},

        getMetaTagsSelectors: function () {
            return [
                'meta[name="robots"]',
                'meta[name="yandex"]',
                'meta[name="keywords"]',
                'meta[name="description"]',
                'link[rel="canonical"]',
                'link[rel="prev"]',
                'link[rel="next"]',
                'link[rel="alternate"]',
            ];
        },

        processMetaTags: function (metaTags) {
            var selectors = this.getMetaTagsSelectors(),
                newTags = $(metaTags),
                titleTag = $('head > title');

            for (var i = 0, l = selectors.length; i < l; ++i) {
                var selector = selectors[i],
                    oldTag = $(selector),
                    newTag = newTags.filter(selector);

                if (oldTag.length) {
                    if (newTag.length) {
                        newTag.insertAfter(oldTag.filter(':last'));
                        oldTag.remove();
                    } else {
                        oldTag.remove();
                    }
                } else if (newTag.length) {
                    newTag.insertAfter(titleTag.filter(':last'));
                }
            };
        },

        processResponse: function (response, pushState) {
            this.processMetaTags(response.metaTagsHtml);

            for (var name in response.html) {
                var blockSelector = "[data-catalog-view-block='" + name + "']",
                    newBlock = $(response.html[name]).find(blockSelector).addBack(blockSelector),
                    originalBlock = $(blockSelector);

                originalBlock.replaceWith(newBlock);
            }

            if (pushState) {
                this.pushState(response.seo.metaTitle, response.link);
            }

            this.setMetaData(response);
            this.url = response.link;
        },

        followLink: function (link, pushState, callback) {
            if (this.loading || !link) {
                return;
            }

            if (this.trigger('onBeforeFollowLink') === false) {
                return;
            }

            pushState = pushState === undefined ? true : pushState;
            this.loading = true;

            var self = this;

            this.trigger('onBeforeAjax');

            return sendAjax(link, {catalogBuilder : 1}, function (status, response) {
                self.trigger('onFollowLink', status, response);
                self.trigger('onAfterAjax');
                self.loading = false;
                if (status === 'OK') {
                    self.processResponse(response, pushState);
                    self.trigger('onChange', response);
                }

                if (typeof callback === 'function') {
                    callback(status, response);
                }
            }, "POST");
        },

        followFilter: function (link, pushState, callback) {
            if (this.loading || !link) {
                return;
            }

            if (this.trigger('onBeforeFollowLink') === false) {
                return;
            }

            pushState = pushState === undefined ? true : pushState;
            this.loading = true;

            var self = this;

            this.trigger('onBeforeAjax');

            return sendAjax(link, {followFilter : 1}, function (status, response) {
                self.trigger('onFollowLink', status, response);
                self.trigger('onAfterAjax');
                self.loading = false;
                if (status === 'OK') {
                    self.processResponse(response, pushState);
                    self.trigger('onChange', response);
                    self.trigger('onFollowFilterChange', response);
                }

                if (typeof callback === 'function') {
                    callback(status, response);
                }
            }, "POST");
        },

        init: function () {
            if (cache === null) {
                cache = new TMCache(10);
            }
            if (this.trigger('onBeforeInit') === false) {
                return;
            }
            this.initHistory();

            this.trigger('onAfterInit');

            this.initialized = true;

        },

        initHistory: function () {
            if (w.history) {
                var self = this;
                $(w).off('popstate.builder').on('popstate.builder', function () {
                    const currentUrl    = w.location.pathname + w.location.search,
                          getPageRegexp = new RegExp(/(page=)(?<page>[0-9]+)/),
                          curUrlPage    = currentUrl.match(getPageRegexp),
                          prevUrlPage   = self.url.match(getPageRegexp);

                    if (curUrlPage === null && prevUrlPage === null && currentUrl !== self.url) {
                        self.followFilter(currentUrl, false);
                    } else if (currentUrl !== self.url && curUrlPage !== null) {
                        self.followLink(currentUrl, false);
                    } else if (currentUrl !== self.url && prevUrlPage !== null) {
                        self.followLink(currentUrl, false);
                    }
                });
            }
        },

        follow: function (link) {
            w.location.href = link;
        },

        pushState: function (title, url) {
            if (w.history && w.history.pushState) {
                w.history.pushState({}, title, url);
            }
        },

        setMetaData: function (response) {
            var head = $(document).find('head');
            head.find('title').text(response.seo.metaTitle);
            this.trigger('onMetaDataSet');
        },

        changeModification: function (selector, id, type) {
            var me = this;
            var a = $(selector),
                container = a.parents('.j-product-container:first');
            if (this.trigger('onBeforeChangeModification', a) === false) {
                return;
            }
            a.siblings().removeClass('__active');
            a.addClass('__active');

            var push_data = function (html) {
                var data = $(html);
                if (!data.is('.j-product-container')) {
                    data = data.find('.j-product-container:first');
                }

                preloadImages(data, function () {
                    data.insertAfter(container);
                    container.remove();
                    me.trigger('onChangeModification', a);
                });
            };

            var cache = this.readByKey('catalog/' + id + '/modification-card');
            if (cache === null) {
                sendAjax(GLOBAL.URI_PREFIX + 'catalog/mini-card/' + id + '/' + type + '/', null, function (status, response) {
                    if (status === 'OK') {
                        me.writeByKey('catalog/' + id + '/modification-card', response.html);
                        push_data(response.html);
                    }
                });
            } else {
                push_data(cache);
            }
        },

        initAdditionalDataLoading: function () {
            $('.j-download-required').parents('.j-product-container').off('mouseenter').one('mouseenter', function () {
                var me = $(this),
                    container = me.find('.j-download-required'),
                    id = me.data('id');
                if (me.data('loading')) {
                    return;
                }
                me.data('loading', true);
                container.removeClass('j-download-required').addClass('__loading');
                sendAjax(GLOBAL.URI_PREFIX + 'catalog/load-additional-data/' + id, null, function (status, response) {
                    container.removeClass('__loading');
                    if (status === "OK") {
                        container.empty().append(response.html);
                        CatalogBuilder.trigger('onAdditionalDataLoaded');
                    }
                });
            });
        },

        setInitialPage: function (value, override) {
            override = override || false;

            if (this.initialPage && !override) {
                return;
            }
            this.initialPage = value;
        },

        resetInitialPage: function () {
            this.initialPage = null;
        }
    };

    $.extend(CatalogBuilder, TMEvents);

    w.CatalogBuilder = CatalogBuilder;

    var preloadImages = function (html, callback) {
        var container = $(html),
            images = $.merge(container.filter('img'), container.find('img')),

            count = images.length;

        var processImage = function () {
            if (--count <= 0) {
                if (typeof callback == 'function') {
                    callback();
                }
            }
        };
        var imgs = [];
        images.each(function () {
            var img = new Image();
            img.onload = processImage;
            img.onerror = processImage;

            img.src = this.src;

            imgs.push(img);
        });
    };

})(jQuery, window);